import React from "react";
import { FaFacebookF, FaTwitter, FaDribbble, FaLinkedinIn } from "react-icons/fa";
import { MdSend } from "react-icons/md";
import { Link } from "react-router-dom";
import "../Footer/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-header">
        <div className="top-f">
          <h3>BUILDING A SUSTAINABLE FUTURE.</h3>
          <h1>Ready to maximize your mining potential?</h1>
        </div>
        <div className="top-f">
          <p>
            Delivering innovative mining solutions while ensuring a sustainable approach for a better tomorrow
          </p>
          <div className="footer-buttons">
          <Link to="/contactus">
            <button className="contact-btn">CONTACT US</button>
            </Link>
            <Link to="/contactus">
            <button className="get-started-btn">GET STARTED</button>
            </Link>
          </div>
        </div>
      </div>

      <hr />

      <div className="footer-content">
        <div className="footer-section">
          <p>
            Empowering mining and resource industries with cutting-edge technologies and sustainable strategies. Let’s shape the future together!
          </p>
          <div className="social-iconss">
            <FaFacebookF className="footer-social" />
            <FaTwitter className="footer-social" />
            <FaDribbble className="footer-social" />
            <FaLinkedinIn className="footer-social" />
          </div>
        </div>
        <div className="footer-section">
          <h4>Explore</h4>
          <ul>
          <Link className="link-t" to="/">
            <li>Home</li>
            </Link>
            <Link className="link-t" to="aboutus">
            <li>About Us</li>
            </Link>
            <Link className="link-t" to="/services/1">
            <li>Services</li>
            </Link>
            <Link className="link-t" to="/contactus">
            <li>Contact</li>
            </Link>
            
          </ul>
        </div>
        <div className="footer-section">
          <h4>Our Expertise</h4>
          <ul>
          <Link className="link-t" to="/services/1">
            <li>Exploration and Surveying</li>
            </Link>
            <Link className="link-t" to="/services/2">
            <li>Resource Extraction</li>
            </Link>
            <Link className="link-t" to="/services/3">
            <li>Mining Safety & Risk Management</li>
            </Link>
            <Link className="link-t" to="/services/4">
            <li>Environmental Management</li>
            </Link>
           
          </ul>
        </div>
        <div className="footer-section">
          <h4>Stay Updated</h4>
          <form>
            <input type="email" placeholder="Enter your email" />
            <button type="submit">
              <MdSend />
            </button>
          </form>
          <div className="ind">
            <input className="in" type="checkbox" />
            <label>I agree to the terms and privacy policy.</label>
          </div>
        </div>
      </div>

      <div className="footer-ticker">
        <p className="quote">"Mining responsibly, building the future"</p>
      </div>

      <div className="footer-bottom">
        <p>Help / Terms & Conditions / Privacy Policy</p>
        <p>Copyright © 2024 Mining. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
